<div data-e2e-id="xux-list-container" class="xux xux-list-container" [ngClass]="isCollapsed ? 'collapsed-wrap' : ''">
  <xux-document-info-error-message
    *ngIf="isDocumentInfoMessageShow$ | async"
    [messageData]="infoMessageData$ | async"
  ></xux-document-info-error-message>
  <div  class="collapsed-icons-container"  (click)="onSwitchIcon()">
    <h4 *ngIf="isCollapsed">
      {{ headerName | translate}}
    </h4>
    <xux-icon [class.visible]="isCollapsed" class="dm-grid-sort-icon" [ngClass]="isCollapsed ? 'top-12' : ''" icon="icon-arrow-up"></xux-icon>
    <xux-icon [class.visible]="!isCollapsed" class="dm-grid-sort-icon dm-icon-arrow-down" icon="icon-arrow-down"></xux-icon>
  </div>
  <div [ngClass]="isCollapsed ? 'display-none' : ''" class="xux-list-wrapper">
  <div class="row">
    <div class="xux-top-panel">
      <div data-e2e-id="xux-list-title" class="col-xs-6 title-area">
        <h4>
          {{ headerName | translate }}
          <span class="deleted-text" *ngIf="inShowDeletedMode">{{ I18n.Forms.GridMessages.DeletedItems | translate}}</span>
          <xux-tooltip-icon
            *ngIf="titleTooltipIconConfig$ | async"
            [config]="titleTooltipIconConfig$ | async"
            class="ws-connection-icon orange"
          ></xux-tooltip-icon>
        </h4>
        <span class="sub-info" *ngIf="description">{{ description | translate }}<br /></span>
        <span class="sub-info" *ngIf="!disableItemsCountLabel">
          {{
            I18n.Forms.GridMessages.ShowingEntities | translate: { count: (isServerFilter(userGridOptions.enableServerSideFilter) ? (total$  | async) : pageSideTotal) || 0, entities: listTotalItemsLabel$ | async }
          }}
        </span>
      </div>
    </div>
  </div>

  <xux-grid
    #listGrid
    class="xux-list"
    [class.show-deleted-mode]="inShowDeletedMode"
    [ngClass]="classes"
    data-e2e-id="xux-list"
    [items]="items$ | async"
    [columns]="columnDefinitions"
    [view]="viewConfig"
    [options]="gridOptions"
    [buttons]="actionButtons"
    [rowButtons]="rowActionButtons"
    [showLoader]="disableLoader"
    [userComponents]="xviCustomGridComponents"
    [pageCount]="pageCount$ | async"
    [userGridOptions]="userGridOptions"
    (action)="onGridAction($event)"
    [i18n]="staticI18nTextContent?.xuxGrid"
  >
  </xux-grid>
  </div>
</div>
